export default "/images/d4d935533c9a2055f6f6f0a23f728ccd.avif";